var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#0E4AFB",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.758 24.2547C19.8433 25.1432 19.988 25.8036 20.187 26.2393C20.3885 26.6735 20.7463 26.8901 21.2627 26.8901C21.3592 26.8901 21.4456 26.875 21.5312 26.8575C21.619 26.875 21.705 26.8901 21.8023 26.8901C22.3173 26.8901 22.6761 26.6735 22.8765 26.2393C23.0766 25.8036 23.2188 25.1432 23.3059 24.2547L23.7644 17.3942C23.8497 16.057 23.8932 15.0975 23.8932 14.5151C23.8932 13.7224 23.6864 13.1039 23.2715 12.6598C22.8551 12.2157 22.3081 11.9941 21.6306 11.9941C21.5944 11.9941 21.5674 12.0022 21.5319 12.0036C21.4982 12.0022 21.4705 11.9941 21.4354 11.9941C20.7564 11.9941 20.2105 12.2157 19.7949 12.6598C19.3796 13.1046 19.1714 13.7235 19.1714 14.5155C19.1714 15.0979 19.2139 16.0574 19.3006 17.3946L19.758 24.2547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5492 29.3977C20.8913 29.3977 20.3324 29.6052 19.8683 30.0201C19.4045 30.4354 19.1721 30.9396 19.1721 31.5315C19.1721 32.1995 19.4073 32.7254 19.8742 33.1074C20.3433 33.4894 20.8902 33.6803 21.5155 33.6803C22.152 33.6803 22.707 33.4922 23.1816 33.1148C23.6556 32.7384 23.8925 32.2097 23.8925 31.5322C23.8925 30.9403 23.6657 30.4362 23.2122 30.0208C22.7586 29.6052 22.2043 29.3977 21.5481 29.3977",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4681,
    height: 22.4681,
    fill: "white",
    transform: "translate(10.2976 11.2339)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.97de90bbee86d2fd6d07824efda2111d.svg";
export { ForwardRef as ReactComponent };